export const IMG = {
  hero: "https://images.pexels.com/photos/33170458/pexels-photo-33170458.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
  heroPortrait: "https://images.unsplash.com/photo-1555820585-c5ae44394b79?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  makeup: "https://images.unsplash.com/photo-1533562389935-457b1ae48a39?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  skincare: "https://images.unsplash.com/photo-1631730486572-226d1f595b68?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  fashion: "https://images.pexels.com/photos/14577586/pexels-photo-14577586.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  swatches: "https://images.unsplash.com/photo-1608231261603-42c08866e163?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  glow: "https://images.unsplash.com/photo-1581182815808-b6eb627a8798?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  outfit: "https://images.pexels.com/photos/5629269/pexels-photo-5629269.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=760&w=900",
  hair: "https://images.unsplash.com/photo-1675034743339-0b0747047727?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
};

export const STUDIO = {
  womanLips: "https://images.pexels.com/photos/8092952/pexels-photo-8092952.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=760&w=760",
  womanFace: "https://images.unsplash.com/photo-1556942057-94aaf3ae5d6e?crop=entropy&cs=srgb&fm=jpg&q=85&w=760",
  manFace: "https://images.unsplash.com/photo-1547729047-a1f1532c9a38?crop=entropy&cs=srgb&fm=jpg&q=85&w=760",
  makeupInspo: [
    "https://images.pexels.com/photos/10539537/pexels-photo-10539537.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=600",
    "https://images.unsplash.com/photo-1528047128849-2382ff646073?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    "https://images.unsplash.com/photo-1597826322461-9b11d306d08f?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  ],
  jewelry: [
    "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    "https://images.unsplash.com/photo-1585960622850-ed33c41d6418?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    "https://images.pexels.com/photos/36536669/pexels-photo-36536669.png?auto=compress&cs=tinysrgb&dpr=2&h=600&w=600",
  ],
};
